import React, { useState, useEffect, useMemo, useRef } from 'react';
import { db } from '../firebase';
import { collection, addDoc, onSnapshot, doc, updateDoc, deleteDoc, serverTimestamp, increment, query, orderBy, limit } from "firebase/firestore";

function StockPage() {
  const [urunler, setUrunler] = useState([]);
  const [hareketler, setHareketler] = useState([]);
  
  // Yeni Ürün Formu
  const [ad, setAd] = useState("");
  const [fiyat, setFiyat] = useState("");
  const [stok, setStok] = useState("");
  const [seciliKategoriler, setSeciliKategoriler] = useState([]);
  
  // Filtreler
  const [aramaTerimi, setAramaTerimi] = useState("");
  const [filtreKategori, setFiltreKategori] = useState("HEPSİ");
  
  // DÜZENLEME ÇEKMECESİ (Drawer) STATELERİ
  const [seciliUrun, setSeciliUrun] = useState(null);
  const [duzenlemeAd, setDuzenlemeAd] = useState("");
  const [duzenlemeFiyat, setDuzenlenenFiyat] = useState("");
  const [duzenlemeKategoriler, setDuzenlemeKategoriler] = useState([]);
  const [hareketMiktari, setHareketMiktari] = useState("");
  const [hareketTipi, setHareketTipi] = useState("URETIM");

  const scrollRef = useRef(null);
  const kategoriler = ["ZEYTİNYAĞI", "ZEYTİN", "KOZMETİK", "YAKACAK", "MAKİNA", "SAKLAMA KABI", "HİZMET", "AMBALAJ", "DİĞER", "ÖZEL SERİ", "İNDİRİMLİ"];

  // --- VERİ DİNLEME ---
  useEffect(() => {
    const unsubUrun = onSnapshot(collection(db, "urunler"), (snapshot) => {
      const urunListesi = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setUrunler(urunListesi);
      
      if (seciliUrun) {
        const guncelUrun = urunListesi.find(u => u.id === seciliUrun.id);
        if (guncelUrun) setSeciliUrun(guncelUrun);
      }
    });

    const qHareket = query(collection(db, "stok_hareketleri"), orderBy("tarih", "desc"), limit(20));
    const unsubHareket = onSnapshot(qHareket, (snapshot) => {
      setHareketler(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return () => { unsubUrun(); unsubHareket(); };
  }, [seciliUrun?.id]);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft } = scrollRef.current;
      const scrollTo = direction === 'left' ? scrollLeft - 150 : scrollLeft + 150;
      scrollRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  // Ürüne tıklandığında çekmeceyi hazırlar
  const urunSec = (u) => {
    setSeciliUrun(u);
    setDuzenlemeAd(u.ad || "");
    setDuzenlenenFiyat(u.fiyat || 0);
    setDuzenlemeKategoriler(u.kategori || []);
    setHareketMiktari("");
  };

  const urunEkle = async () => {
    if (!ad || !fiyat || seciliKategoriler.length === 0) return alert("Eksik bilgi!");
    await addDoc(collection(db, "urunler"), {
      ad: ad.toUpperCase(),
      fiyat: Number(fiyat),
      stok: Number(stok) || 0,
      kategori: seciliKategoriler,
      isHizmet: seciliKategoriler.includes("HİZMET"),
      tarih: serverTimestamp()
    });
    setAd(""); setFiyat(""); setStok(""); setSeciliKategoriler([]);
  };

  const stokHareketiEkle = async () => {
    if (!seciliUrun) return;
    if (!hareketMiktari || hareketMiktari <= 0) return alert("Geçerli bir miktar girin!");
    
    const urunRef = doc(db, "urunler", seciliUrun.id);
    await updateDoc(urunRef, { stok: increment(Number(hareketMiktari)) });

    await addDoc(collection(db, "stok_hareketleri"), {
      urunId: seciliUrun.id,
      urunAd: seciliUrun.ad,
      miktar: Number(hareketMiktari),
      tip: hareketTipi,
      tarih: serverTimestamp()
    });

    setHareketMiktari("");
    alert("Stok girişi işlendi.");
  };

  const alanGuncelle = async (id, alan, deger) => {
    await updateDoc(doc(db, "urunler", id), { [alan]: deger });
  };

  const kaydetDuzenleme = async () => {
    if (!seciliUrun) return;
    if (!duzenlemeAd) return alert("Ürün adı boş olamaz!");

    try {
      const urunRef = doc(db, "urunler", seciliUrun.id);
      await updateDoc(urunRef, {
        ad: duzenlemeAd.toUpperCase(),
        fiyat: Number(duzenlemeFiyat),
        kategori: duzenlemeKategoriler,
        isHizmet: duzenlemeKategoriler.includes("HİZMET")
      });
      alert("Ürün başarıyla güncellendi!");
      setSeciliUrun(null); // Güncelleme bitince pencereyi otomatik kapatır
    } catch (error) {
      alert("Hata oluştu.");
    }
  };

  const filtrelenmisUrunler = useMemo(() => {
    return urunler.filter(u => {
      const urunAdi = u.ad ? u.ad.toLowerCase() : "";
      const adUygun = urunAdi.includes(aramaTerimi.toLowerCase());
      const katUygun = filtreKategori === "HEPSİ" || 
                       (Array.isArray(u.kategori) ? u.kategori.includes(filtreKategori) : u.kategori === filtreKategori);
      return adUygun && katUygun;
    }).sort((a, b) => (a.ad || "").localeCompare(b.ad || ""));
  }, [urunler, aramaTerimi, filtreKategori]);

  return (
    <div className="flex flex-col lg:flex-row h-screen bg-slate-950 text-white overflow-hidden font-sans relative">
      
      {/* 1. BÖLÜM: SOL PANEL - ÜRÜN TANIMLAMA */}
      <div className="w-full lg:w-[350px] p-5 border-b lg:border-b-0 lg:border-r border-slate-900 bg-slate-900/30 shrink-0 flex flex-col custom-scrollbar overflow-y-auto h-full">
        <h2 className="text-lg font-black mb-5 italic text-blue-500 uppercase tracking-tighter">📦 Ürün Tanımla</h2>
        <div className="space-y-4">
          <input value={ad} onChange={(e)=>setAd(e.target.value)} placeholder="ÜRÜN ADI" className="w-full bg-slate-900 p-3.5 rounded-2xl outline-none border border-slate-800 focus:border-blue-500 text-xs font-bold uppercase"/>
          <div className="grid grid-cols-2 gap-2">
            <input type="number" value={fiyat} onChange={(e)=>setFiyat(e.target.value)} placeholder="FİYAT ₺" className="bg-slate-900 p-3.5 rounded-2xl outline-none border border-slate-800 text-xs font-bold text-emerald-400"/>
            <input type="number" value={stok} onChange={(e)=>setStok(e.target.value)} placeholder="BAŞL. STOK" className="bg-slate-900 p-3.5 rounded-2xl outline-none border border-slate-800 text-xs font-bold text-blue-400" disabled={seciliKategoriler.includes("HİZMET")}/>
          </div>
          <div className="bg-slate-900/50 p-4 rounded-2xl border border-slate-900">
            <p className="text-[9px] font-black text-slate-500 mb-3 uppercase tracking-widest text-center italic">- KATEGORİ SEÇ -</p>
            <div className="grid grid-cols-2 gap-2 max-h-[140px] overflow-y-auto pr-1 custom-scrollbar">
              {kategoriler.map(k => (
                <button key={k} onClick={() => setSeciliKategoriler(prev => prev.includes(k) ? prev.filter(x=>x!==k) : [...prev, k])}
                  className={`p-2 rounded-xl text-[9px] font-black border truncate transition-all ${seciliKategoriler.includes(k) ? 'bg-blue-600 border-blue-400 text-white' : 'bg-slate-950 border-slate-800 text-slate-500 hover:border-slate-600'}`}>{k}</button>
              ))}
            </div>
          </div>
          <button onClick={urunEkle} className="w-full bg-blue-600 hover:bg-blue-500 p-4 rounded-2xl font-black text-xs uppercase tracking-wider shadow-lg active:scale-95 transition-all">Sisteme Kaydet</button>
        </div>

        {/* HAREKET GEÇMİŞİ */}
        <div className="mt-6 pt-5 border-t border-slate-900 flex-1 overflow-y-auto custom-scrollbar">
          <h3 className="text-[9px] font-black text-slate-500 uppercase tracking-widest mb-3">🕒 Son Stok Hareketleri</h3>
          <div className="space-y-2">
            {hareketler.map(h => (
              <div key={h.id} className="bg-slate-900/40 p-3 rounded-xl border border-white/5 flex justify-between items-center">
                <div className="min-w-0 flex-1 pr-2">
                  <p className="text-[10px] font-black truncate uppercase">{h.urunAd}</p>
                  <p className="text-[8px] text-slate-500 font-bold">{h.tip} • {h.tarih?.toDate().toLocaleTimeString('tr-TR')}</p>
                </div>
                <div className={`font-black text-xs shrink-0 ${h.tip === 'URETIM' ? 'text-blue-400' : 'text-emerald-400'}`}>+{h.miktar}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 2. BÖLÜM: ORTA - STOK LİSTESİ (ŞİMDİ EKRANI TAM KAPLIYOR) */}
      <div className="flex-1 flex flex-col min-h-0 h-full">
        <div className="p-4 bg-slate-950 border-b border-slate-900">
          <input type="text" placeholder="Ürün listesinde hızlı ara..." value={aramaTerimi} onChange={(e)=>setAramaTerimi(e.target.value)} className="w-full bg-slate-900 border border-slate-800 p-3 rounded-xl outline-none focus:border-blue-500 font-bold text-xs" />
          <div className="flex items-center gap-2 relative mt-3">
            <button onClick={() => scroll('left')} className="p-2 bg-slate-900 border border-slate-800 rounded-lg text-xs font-bold text-blue-500">&lt;</button>
            <div ref={scrollRef} className="flex-1 flex gap-2 overflow-x-auto no-scrollbar scroll-smooth">
              {["HEPSİ", ...kategoriler].map(k => (
                <button key={k} onClick={()=>setFiltreKategori(k)} className={`px-4 py-2 rounded-full text-[10px] font-black whitespace-nowrap transition-all border shrink-0 ${filtreKategori === k ? 'bg-white text-black border-white' : 'bg-slate-900 text-slate-500 border-slate-800 hover:border-slate-600'}`}>
                  {k}
                </button>
              ))}
            </div>
            <button onClick={() => scroll('right')} className="p-2 bg-slate-900 border border-slate-800 rounded-lg text-xs font-bold text-blue-500">&gt;</button>
          </div>
        </div>

        {/* ÜRÜN KARTLARI */}
        <div className="flex-1 overflow-y-auto p-4 space-y-2 custom-scrollbar">
          {filtrelenmisUrunler.map(u => (
            <div key={u.id} 
                 onClick={() => urunSec(u)}
                 className="p-4 rounded-2xl bg-slate-900/30 border border-slate-900/60 hover:border-slate-700 hover:bg-slate-900/50 cursor-pointer transition-all">
              
              <div className="flex justify-between items-center">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-black text-xs uppercase truncate text-slate-200">{u.ad}</h3>
                    {u.stok < 10 && !u.isHizmet && <span className="text-[7px] bg-red-600/20 text-red-500 border border-red-500/20 px-1.5 py-0.5 rounded font-black animate-pulse">KRİTİK</span>}
                  </div>
                  <div className="flex gap-1 overflow-hidden">
                    {(Array.isArray(u.kategori) ? u.kategori : [u.kategori]).map(k => (
                      <span key={k} className="text-[7px] font-black px-1.5 py-0.5 rounded bg-blue-500/10 text-blue-400 border border-blue-500/10 uppercase">{k}</span>
                    ))}
                  </div>
                </div>
                
                <div className="flex items-center gap-4 ml-4 shrink-0" onClick={(e) => e.stopPropagation()}>
                  <div className="text-right">
                    <p className="text-emerald-400 font-black italic text-xs leading-none">{u.fiyat} TL</p>
                    <p className="text-[8px] text-slate-600 font-bold mt-1 uppercase">Fiyat</p>
                  </div>

                  <div className="flex items-center gap-2 bg-black/40 p-1.5 px-2.5 rounded-xl border border-slate-900">
                    <button onClick={() => alanGuncelle(u.id, "stok", Math.max(0, u.stok - 1))} className="text-slate-500 hover:text-white font-black text-xs px-1">-</button>
                    <div className="flex flex-col items-center min-w-[25px]">
                      <span className={`font-black italic text-xs ${u.stok <= 0 && !u.isHizmet ? 'text-red-500' : 'text-white'}`}>
                        {u.isHizmet ? '∞' : u.stok}
                      </span>
                    </div>
                    <button onClick={() => alanGuncelle(u.id, "stok", (u.stok || 0) + 1)} className="text-blue-500 hover:text-white font-black text-xs px-1">+</button>
                  </div>

                  <button 
                    onClick={() => window.confirm(`${u.ad} tamamen silinecek. Emin misiniz?`) && deleteDoc(doc(db, "urunler", u.id))} 
                    className="w-8 h-8 flex items-center justify-center bg-slate-900 border border-slate-800 rounded-xl text-slate-600 hover:bg-red-600 hover:text-white transition-all shadow-lg active:scale-90"
                  >
                    🗑️
                  </button>
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>

      {/* 3. BÖLÜM: YENİ AÇILIR ÇEKMECE PANELİ (EKRANA TAM SIĞAR, SAĞDAN KAYARAK ÜSTE GELİR) */}
      <div className={`fixed top-0 right-0 h-full w-full sm:w-[400px] bg-slate-900 border-l border-slate-800 p-6 shadow-2xl z-50 transform transition-transform duration-300 flex flex-col ${seciliUrun ? 'translate-x-0' : 'translate-x-full'}`}>
        {seciliUrun && (
          <div className="space-y-6 flex flex-col h-full justify-between overflow-y-auto custom-scrollbar">
            
            <div className="space-y-6">
              {/* Kapatma Butonu Üstte */}
              <div className="flex justify-between items-center border-b border-slate-800 pb-3">
                <div>
                  <span className="text-[9px] font-black text-blue-500 uppercase tracking-widest block">Ürün Düzenleme</span>
                  <h2 className="text-lg font-black uppercase italic tracking-tighter text-white mt-1 max-w-[240px] truncate">{seciliUrun.ad}</h2>
                </div>
                <button onClick={() => setSeciliUrun(null)} className="bg-slate-800 hover:bg-slate-700 text-slate-400 font-black px-3 py-1.5 rounded-xl text-xs uppercase transition-all">❌ KAPAT</button>
              </div>

              {/* A) ÜRÜN KARTINI DEĞİŞTİR */}
              <div className="space-y-3 bg-black/30 p-4 rounded-2xl border border-white/5">
                <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-wider mb-1">✏️ Kart Bilgilerini Değiştir</h3>
                
                <div>
                  <label className="text-[9px] text-slate-500 font-black uppercase ml-1">Ürün Adı (Düzeltme)</label>
                  <input value={duzenlemeAd} onChange={(e)=>setDuzenlemeAd(e.target.value)} className="w-full bg-slate-950 p-3 rounded-xl border border-slate-800 font-bold text-xs uppercase text-white mt-1 outline-none focus:border-blue-500" />
                </div>

                <div>
                  <label className="text-[9px] text-slate-500 font-black uppercase ml-1">Satış Fiyatı (₺)</label>
                  <input type="number" value={duzenlemeFiyat} onChange={(e)=>setDuzenlenenFiyat(e.target.value)} className="w-full bg-slate-950 p-3 rounded-xl border border-slate-800 font-bold text-sm text-emerald-400 mt-1 outline-none focus:border-emerald-500" />
                </div>

                <div>
                  <label className="text-[9px] text-slate-500 font-black uppercase ml-1">Kategoriler</label>
                  <div className="grid grid-cols-2 gap-1.5 mt-1 max-h-[100px] overflow-y-auto pr-1 custom-scrollbar">
                    {kategoriler.map(k => (
                      <button key={k} onClick={() => setDuzenlemeKategoriler(prev => prev.includes(k) ? prev.filter(x=>x!==k) : [...prev, k])}
                        className={`p-1.5 rounded-lg text-[8px] font-black border truncate transition-all ${duzenlemeKategoriler.includes(k) ? 'bg-blue-600 border-blue-500 text-white' : 'bg-slate-950 border-slate-800 text-slate-600'}`}>{k}</button>
                    ))}
                  </div>
                </div>

                <button onClick={kaydetDuzenleme} className="w-full bg-blue-600 hover:bg-blue-500 p-2.5 rounded-xl font-black text-[10px] uppercase mt-2 tracking-wider">Değişiklikleri Kaydet</button>
              </div>

              {/* B) STOK EKLEME PANELİ */}
              {!seciliUrun.isHizmet && (
                <div className="space-y-3 bg-black/30 p-4 rounded-2xl border border-white/5">
                  <h3 className="text-[10px] font-black text-orange-500 uppercase tracking-wider mb-1">📥 Ambara Stok Ekle</h3>
                  
                  <div className="flex gap-2">
                    <div className="flex-1">
                      <label className="text-[9px] text-slate-500 font-black uppercase ml-1">Miktar</label>
                      <input type="number" placeholder="0" value={hareketMiktari} onChange={(e)=>setHareketMiktari(e.target.value)} className="w-full bg-slate-950 p-3 rounded-xl border border-slate-800 font-bold text-center text-sm text-white mt-1 outline-none" />
                    </div>
                    <div className="w-[130px]">
                      <label className="text-[9px] text-slate-500 font-black uppercase ml-1">İşlem Tipi</label>
                      <select value={hareketTipi} onChange={(e)=>setHareketTipi(e.target.value)} className="w-full bg-slate-950 p-3 rounded-xl border border-slate-800 font-bold text-xs text-white mt-1 outline-none cursor-pointer">
                        <option value="URETIM">⚙️ ÜRETİM</option>
                        <option value="SATINALMA">🛒 SATIN ALMA</option>
                      </select>
                    </div>
                  </div>

                  <button onClick={stokHareketiEkle} className="w-full bg-emerald-600 hover:bg-emerald-500 p-3 rounded-xl font-black text-[10px] uppercase tracking-wider mt-1">Stok Girişini Onayla</button>
                </div>
              )}
            </div>

            <div className="text-[9px] text-center text-slate-600 font-bold mt-4">
              Mevcut Stok Miktarı: {seciliUrun.isHizmet ? 'Sınırsız' : `${seciliUrun.stok} Adet`}
            </div>

          </div>
        )}
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar { width: 4px; height: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #1e293b; border-radius: 10px; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}

export default StockPage;